<template>
  <main class="wiki-page container">
    <header class="wiki-hero">
      <img src="/wiki/manual-v1/images/image1.png" alt="Visor GRD" />
      <div><p class="wiki-eyebrow">Centro de conocimiento</p><h1>Instructivos Visor GRD</h1><p>Manual de usuario, navegación y herramientas del visor cartográfico.</p></div>
    </header>
    <div class="wiki-actions" v-if="canAdmin"><router-link class="btn btn-secondary" to="/wiki/admin">Administrar Instructivos</router-link></div>
    <WikiSearch :initial-query="$route.query.q || ''" :sync-url="true" />
    <section>
      <h2>Capítulos</h2>
      <p v-if="loading" class="wiki-muted">Cargando artículos…</p>
      <p v-else-if="error" class="wiki-error">{{ error }}</p>
      <div v-else class="wiki-card-grid">
        <router-link v-for="article in articles" :key="article.id" :to="`/wiki/${article.slug}`" class="wiki-card">
          <strong>{{ article.title }}</strong><span>{{ article.summary }}</span>
        </router-link>
      </div>
    </section>
  </main>
</template>
<script>
import WikiSearch from './WikiSearch.vue'
import { createWikiApi } from '@/services/wiki/api.js'
export default {
  name: 'WikiHome', components: { WikiSearch },
  data() { return { articles: [], loading: true, error: '' } },
  computed: { canAdmin() { const p = this.$store.getters.getPermissions; return !!(p && p.wiki) } },
  created() { createWikiApi(this.$http, this.$store.getters.backendurl).list().then(r => { this.articles = r.data || [] }).catch(() => { this.error = 'No fue posible cargar los instructivos.' }).finally(() => { this.loading = false }) },
}
</script>
<style lang="scss">@import './wiki.scss';</style>
